import request from '@/utils/vip_request'
import ucenter_request from '@/utils/ucenter_request'
import bbs_request from '@/utils/bbs_request'
// 专题页面详情
export function getDetail(params) {
  return request({
    url: 'special/special/getDetail',
    method: 'get',
    params: params
  })
}
// 专题页面免费课程
export function getFreeLesson(params) {
  return request({
    url: 'special/special/getFreeLesson',
    method: 'get',
    params: params
  })
}
// 专题页面免费资料
export function getFreeThread(params) {
  return request({
    url: 'special/special/getFreeThread',
    method: 'get',
    params: params
  })
}
// 专题页面折扣课程
export function getDiscountLesson(params) {
  return request({
    url: 'special/special/getDiscountLesson',
    method: 'get',
    params: params
  })
}
// 收藏
export function saveVipCardCollection(params) {
  return ucenter_request({
    url: 'personal/Myinfo/saveVipCardCollection',
    method: 'get',
    params: params
  })
}
// 获取全部专业
export function category(params) {
  return bbs_request({
    url: 'home/resource/category',
    method: 'get',
    params: params
  })
}
// 专业对应专题
export function getVipSpecial(params) {
  return request({
    url: 'special/special/getVipSpecial',
    method: 'get',
    params: params
  })
}
